import React, { useEffect, useState } from "react";
import "./style.scss";
import "../../../../style/block.scss";
import "../../../../style/variables.scss";
import "../../../../style/buttons.scss";
import "../../../../style/forms.scss";
import "../../../../style/feature.scss";
import "../../../../style/hovers.scss";
import { AiFillCheckCircle, AiOutlineCheck, AiOutlineUserAdd } from "react-icons/ai";
import { BiLogInCircle } from "react-icons/bi";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import { useDispatch, useSelector } from "react-redux";
import { logInWithPassword } from "../../../../app/store/auth/authActions";
import { LoginData } from "../../../models/LoginData";
import useFacility from "../../../../utils/hooks/useFacility";
import { useNavigate } from "react-router";
import { REGISTRATION_PAGE } from "../../../routes";
import { State } from "../../../store";
import { USER_TOKEN } from "../../../store/auth/authMiddleware";
import useParentMessage from "../../../../utils/hooks/useParentMessage";
import { useTranslation } from "react-i18next";

interface IProps {
  setStep: (index: number) => void;
}

const initialFormLogin: LoginData = {
  login: "",
  password: "",
  objectIds: "",
  old_token: "",
};
const BasketSecondStep: React.FC<IProps> = ({ setStep }: IProps) => {
  const { t } = useTranslation();
  const isDesktop = useDesktopSize();
  const dispatch = useDispatch();
  const facilityIds = useFacility();
  const userToken = sessionStorage.getItem(USER_TOKEN);
  const parsedUserToken = userToken ? JSON.parse(userToken).sessionToken : "";
  const [form, setForm] = useState<LoginData>({
    ...initialFormLogin,
    objectIds: facilityIds,
    old_token: parsedUserToken,
  });
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const { scrollToTop } = useParentMessage();
  const navigate = useNavigate();
  const alertLogin = useSelector((state: State) => state.alerts.errors);
  const isLogged = useSelector((state: State) => state.auth.isLoggedIn);

  useEffect(() => {
    if (isLogged) {
      setStep(4);
    }
    if (!saleConfiguration.allowToMakeAccount) {
      setStep(3);
    }
  }, [isLogged]);

  return (
    <React.Fragment>
      {isDesktop ? (
        <div className="basket-second-step flex-between">
          {saleConfiguration.allowToMakeAccount && (
            <React.Fragment>
              <div className="padding-big box shadow border">
                <h2>{t("zaloguj_sie")}</h2>

                <div className="forms">
                  <div className="form-icon">
                    <input
                      className="form-label"
                      placeholder={t("adres_email")}
                      value={form.login}
                      onChange={(event) => setForm({ ...form, login: event.target.value })}
                    />
                    <AiFillCheckCircle className="icon-succes" />
                  </div>

                  <div className="form-icon">
                    <input
                      className="form-label"
                      placeholder={t("haslo")}
                      type="password"
                      value={form.password}
                      onChange={(event) => setForm({ ...form, password: event.target.value })}
                    />
                    <AiFillCheckCircle className="icon-succes" />
                  </div>
                  {alertLogin && alertLogin.length > 0 && <div className="alert alert-red">{alertLogin}</div>}

                  <button
                    className="button full-button big button-fill-main  move-up"
                    onClick={() => dispatch(logInWithPassword(form))}
                  >
                    {t("zaloguj_sie")}
                    <BiLogInCircle className="icon-second" />
                  </button>
                </div>
              </div>

              <div className="padding-big box shadow border">
                <h2>{t("utworz_konto")}</h2>
                <button
                  className="button full-button big button-fill-main move-up"
                  onClick={() => navigate(REGISTRATION_PAGE)}
                >
                  {t("zarejestruj_sie")}
                  <AiOutlineUserAdd className="icon-second" />
                </button>
                <ul className="ul">
                  <li className="flex-center-center">
                    <AiOutlineCheck className="icon" />
                    <span className="text-li">{t("szybsze_kolejne_zakupy")}</span>
                  </li>
                  <li className="flex-center-center">
                    <AiOutlineCheck className="icon" />
                    <span className="text-li">{t("pelna_historia_zakupow")}</span>
                  </li>
                  <li className="flex-center-center">
                    <AiOutlineCheck className="icon" />
                    <span className="text-li">{t("ustawienia_przypomnien")}</span>
                  </li>
                </ul>
              </div>
            </React.Fragment>
          )}
          <div className="padding-big box shadow border">
            <h2>{t("zakupy_bez_logowania")}</h2>
            <button
              onClick={() => {
                setStep(3);
                scrollToTop();
              }}
              className="button full-button big button-outline-second move-up "
            >
              {t("kup_bez_rejestracji")}
            </button>
          </div>
        </div>
      ) : (
        <div className="basket-second-step flex-between">
          <div className="padding-big box shadow border">
            <b>{t("zakupy_bez_logowania")}</b>
            <button
              onClick={() => {
                setStep(3);
                scrollToTop();
              }}
              className="button full-button big button-outline-second move-up "
            >
              {t("kup_bez_rejestracji")}
            </button>
          </div>
          {saleConfiguration.allowToMakeAccount && (
            <React.Fragment>
              <div className="padding-big box shadow border">






                
                <b>{t("zaloguj_sie")}</b>
                <div className="forms">
                  <div className="form-icon">
                    <input
                      className="form-label"
                      placeholder={t("adres_email")}
                      value={form.login}
                      onChange={(event) => setForm({ ...form, login: event.target.value })}
                    />
                    <AiFillCheckCircle className="icon-succes" />
                  </div>

                  <div className="form-icon">
                    <input
                      className="form-label"
                      placeholder={t("haslo")}
                      type="password"
                      value={form.password}
                      onChange={(event) => setForm({ ...form, password: event.target.value })}
                    />
                    <AiFillCheckCircle className="icon-succes" />
                  </div>
                  {alertLogin && alertLogin.length > 0 && <div className="alert alert-red">{alertLogin}</div>}

                  <button
                    className="button full-button big button-fill-main  move-up"
                    onClick={() => dispatch(logInWithPassword(form))}
                  >
                    {t("zaloguj_sie")}
                    <BiLogInCircle className="icon-second" />
                  </button>
                </div>
              </div>
              <div className="padding-big box shadow">
                <b>{t("utworz_konto")}</b>
                <button className="button full-button big button-fill-main move-up">
                  {t("zarejestruj_sie")}
                  <AiOutlineUserAdd className="icon-second" />
                </button>
                <ul className="ul">
                  <li className="flex-center-center">
                    <AiOutlineCheck className="icon" />
                    <span className="text-li">{t("szybsze_kolejne_zakupy")}</span>
                  </li>
                  <li className="flex-center-center">
                    <AiOutlineCheck className="icon" />
                    <span className="text-li">{t("pelna_historia_zakupow")}</span>
                  </li>
                  <li className="flex-center-center">
                    <AiOutlineCheck className="icon" />
                    <span className="text-li">{t("ustawienia_przypomnien")}</span>
                  </li>
                </ul>
              </div>
            </React.Fragment>
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default BasketSecondStep;
